export type AddOnKey =
  | "notarization"
  | "mailedHardCopy"
  | "expeditedTurnaround"
  | "desktopPublishing"
  | "proofreading";

export type AddOnConfig = {
  key: AddOnKey;
  title: string;
  description: string;
  badgeText?: string;
  fixedUsd?: number;
  perPageUsd?: number;
  // Per-word rate for Standard tier add-ons (PROD-2026-05-18-002). When
  // set, Step3Options uses calculateStandardAddonCost (per-word with $10
  // floor) instead of the legacy per-page math.
  perWordUsd?: number;
  transitionType: "standard" | "certified";
};

export const ADD_ONS: AddOnConfig[] = [
  {
    key: "notarization",
    // Notarization matches the canonical Stripe price ($19.95).
    // PROD-2026-05-18-007.
    title: "Notarization",
    description:
      "Your certificate will be notarized with the stamp and signature of a notary public to verify authenticity, valid in all 50 states.",
    badgeText: "RECOMMENDED",
    fixedUsd: 19.95,
    transitionType: "certified",
  },
  {
    key: "mailedHardCopy",
    title: "Mailed Hard Copy",
    description: "We'll mail you original signed and ink-stamped copies of your translation.",
    badgeText: "RECOMMENDED",
    fixedUsd: 20,
    transitionType: "certified",
  },
  {
    key: "expeditedTurnaround",
    title: "Expedited Turnaround",
    description: "Get your translations delivered with 12 to 24 hours, guaranteed.",
    badgeText: "RECOMMENDED",
    perPageUsd: 10,
    transitionType: "certified",
  },
  {
    key: "expeditedTurnaround",
    title: "Expedited turnaround",
    description: "Get your translation delivered within 12-24 hours guaranteed.",
    badgeText: "RECOMMENDED",
    perWordUsd: 0.04,
    transitionType: "standard",
  },
  {
    key: "desktopPublishing",
    title: "Desktop Publishing",
    description:
      "If you have special formatting and layout needs for your documents, we’ll work with you to deliver a document that meets your requirements.",
    perWordUsd: 0.04,
    transitionType: "standard",
  },
  {
    key: "proofreading",
    title: "Proofreading",
    description:
      "We’ll give your translated document an additional review for grammar, spelling, and consistency.",
    badgeText: "RECOMMENDED",
    perWordUsd: 0.05,
    transitionType: "standard",
  },
];
